import z from "zod";

export const reasonSchema = z.object({
  value: z.string().trim().min(8, 'Tamanho mínimo: 8 caracteres'),
  file_attachment_attributes: z.object({
    blob_id: z.string().optional(),
    file: z.custom<File>().optional(),
  }),
});

export type ReasonValidationSchema = z.infer<typeof reasonSchema>;
